<template>
  <div class="content">
    <el-tabs
      v-model="editableTabsValue"
      type="card"
      @tab-remove="removeTab"
      @tab-click="clickTab"
    >
      <el-tab-pane
        v-for="(item) in editableTabs"
        :key="item.name"
        :label="item.title"
        :name="item.name"
        :closable="item.closable"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="content-view">
      <keep-alive :include="keepAliveArr">
        <router-view class="content"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRouterAlive: true,  // KeepAlive
    };
  },
  created() {
    // 刷新后回到首页
    if(this.editableTabs.length == 1) {
      this.$router.replace('/home');
    }
  },
  computed: {
    editableTabs: {
      get() {
        return this.$store.state.editableTabs;
      },
      set(val) {
        this.$store.state.editableTabs = val;
      },
    },
    editableTabsValue: {
      get() {
        return this.$store.state.editableTabsValue;
      },
      set(val) {
        this.$store.state.editableTabsValue = val;
      },
    },
    keepAliveArr() {
      return this.$store.state.keepAliveArr;
    },
  },
  mounted() {},
  methods: {
    removeTab(targetName) {
      let tabs = this.editableTabs;
      this.editableTabs.forEach((tab, index) => {
        if (tab.name === targetName) {
          let nextTab = tabs[index + 1] || tabs[index - 1];
          if (nextTab) {
            let name = nextTab.name;
            this.$store.commit("setEditableTabsValue", name);
            this.$router.push({ name });
          }
        }
      });
      this.$store.commit("delEditableTabs", targetName);
    },
    clickTab(value) {
      let name = value.name;
      this.$router.push({ name });
      this.$store.commit("setEditableTabsValue", value.name);
    },
  },
};
</script>

<style lang="scss">
.content {
  .content-view {
    height: calc(100vh - 96px);
    // height: 0px;
    overflow: scroll;
    padding: 0 10px;
  }
}
</style>
